import React from 'react'

function SubmissionDetail() {
  return (
    <div>
      
    </div>
  )
}

export default SubmissionDetail
